import {
  Configuration,
  HTTPHeaders,
} from '@spotify-internal/ads-api-typescript-client-development';
import { RequestOptions, Transport } from '@spotify-internal/transport';

/**
 * Based on the official Ads API recommendation for integrating @spotify-internal/transport
 * with the Ads API Typescript client.
 *
 * Docs: https://ghe.spotify.net/ads/ads-api/blob/master/docs/CLIENT_INTEGRATION_PATTERNS.md#using-the-typescript-client-with-your-preferred-fetch-solution
 */

const DEFAULT_TRANSPORT_OPTIONS: RequestOptions = {
  authorize: false,
  responseType: 'json',
};

const fetchWithTransport = (
  transport: Transport,
  options: RequestOptions,
) => async (requestUrl: RequestInfo | URL, requestData?: RequestInit) => {
  // Type casts required to map similar but different "Request" types
  const transportRequestOptions: RequestOptions = {
    method: requestData?.method as RequestOptions['method'],
    headers: requestData?.headers as RequestOptions['headers'],
    payload: requestData?.body as RequestOptions['payload'],
    ...options,
  };

  const httpResponse = await transport.request(
    requestUrl as string,
    transportRequestOptions,
  );
  return {
    url: httpResponse.url,
    status: httpResponse.status,
    headers: httpResponse.headers,
    ok: httpResponse.ok,
    body: httpResponse.body,
  } as Response;
};

export const getAdsApiConfig = (
  transport: Transport,
  basePath?: string,
  headers: HTTPHeaders = {},
  options: RequestOptions = DEFAULT_TRANSPORT_OPTIONS,
): Configuration => {
  const updatedHeaders = {
    'x-spotify-client-metrics': 'true',
    ...headers,
  };
  return new Configuration({
    basePath,
    // specify preferred fetch solution here
    fetchApi: fetchWithTransport(transport, options),
    headers: updatedHeaders,
  });
};
